import _ from '../../core/utils'
import EVENTS_CONFIG from './config'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import flatpickr from "flatpickr"
import moment from 'moment'

class EventsClass {
    constructor() {
        this.DOM = {
            section: EVENTS_CONFIG.section,
            grid: {
                wrap: EVENTS_CONFIG.grid.wrap,
                items: EVENTS_CONFIG.grid.items,
                calendar: EVENTS_CONFIG.grid.calendar,
                clear: EVENTS_CONFIG.grid.clear
            },
            time: {
                toggle: EVENTS_CONFIG.time.toggle,
                past: EVENTS_CONFIG.time.past,
                upcoming: EVENTS_CONFIG.time.upcoming
            }
        }

        this.past = false
        this.isotope = null
        this.calendar = null
        this.DOM.section ? this.init() : null
    }

    init() {
        this._calendar()
        this._isotope()
        this._listeners()
        console.log( this )
    }

    _listeners() {
        this.DOM.time.toggle.addEventListener( 'click', this._timeToggle.bind( this ) )
        this.DOM.grid.clear.addEventListener( 'click', this._calendarClear.bind( this ) )
    }

    _isotope() {
        this.isotope = new Isotope ( this.DOM.grid.wrap, {
        })

        imagesLoaded( this.DOM.grid.wrap ).on( 'progress', () => {
            this.isotope.layout()
        })

        this.isotope.arrange({
            filter: '.fl__card--calendar, .fl__event--upcoming'
        })
    }

    _calendar() {
        this.calendar = flatpickr( this.DOM.grid.calendar, {
            inline: true,
            monthSelectorType: 'static',
            minDate: "today",
            dateFormat: "d-m-Y",
            static: true,
            onReady: () => {
                this._calendarAddEvents()
            },
            onMonthChange: () => {
                this._calendarAddEvents()
            },
            onYearChange: () => {
                this._calendarAddEvents()
            },
            onChange: () => {
                this._calendarAddEvents()
                this._calendarDaySelected()
            }
        })
    }

    _calendarClear() {
        this.calendar.clear()
        if ( this.past ) {
            this.isotope.arrange({
                filter: '.fl__card--calendar, .fl__event--past'
            })
        } else {
            this.isotope.arrange({
                filter: '.fl__card--calendar, .fl__event--upcoming'
            })
        }
        

        _.removeClass( this.DOM.grid.clear, 'is--active' )
    }

    _calendarAddEvents() {
        this.DOM.grid.items.forEach( ( event ) => {
            let from = moment( event.getAttribute( 'data-event-from' ) ),
                to = moment( event.getAttribute( 'data-event-to' )),
                dates = _.selectAll( `.flatpickr-day:not(.evented)` )
            
            dates.forEach( ( date ) => {
                let dateTime = moment( date.getAttribute( 'aria-label' ) )
                dateTime.isAfter( from ) && dateTime.isBefore( to ) ? _.addClass( date, 'evented--intermediate' ) : null
                dateTime.isSame( from ) || dateTime.isSame( to ) ? _.addClass( date, 'evented' ) : null
            })
            
            
        })
    }

    _calendarAddListener() {
        let days = _.selectAll( '.flatpickr-day ' )
        days.forEach( ( day ) => { day.addEventListener( 'click', this._calendarDaySelected.bind( this ) ) })
    }

    _calendarDaySelected() {
        let target = event.target,
            date = moment( target.getAttribute( 'aria-label' ) )
        
        if ( !_.containClass( target, 'selected' ) ) {
            this.DOM.grid.items.forEach( ( event ) => {
                let from = moment( event.getAttribute( 'data-event-from' ) ),
                    to = moment( event.getAttribute( 'data-event-to' ) )
                
                if ( date >= from && date <= to ) {
                    _.addClass( event, 'fl__event--selected')
                } else {
                    _.removeClass( event, 'fl__event--selected')
                }
            })

            this.isotope.arrange({
                filter: '.fl__event--selected, .fl__card--calendar'
            })

            _.addClass( this.DOM.grid.clear, 'is--active' )

        }
        
    }

    _timeToggle() {
        if ( this.past ) {
            this.calendar.set( 'minDate', 'today' )
            this.calendar.set( 'maxDate', null )
            this.calendar.jumpToDate()
            _.removeClass( this.DOM.section, 'section--events-content--past' )
            this.isotope.arrange({
                filter: '.fl__event--upcoming, .fl__card--calendar'
            })
        } else {
            let yesterday = new Date().getTime() - 24*60*60*1000
            this.calendar.set( 'minDate', null )
            this.calendar.set( 'maxDate', yesterday )
            this.calendar.jumpToDate( yesterday )
            _.addClass( this.DOM.section, 'section--events-content--past' )
            this.isotope.arrange({
                filter: '.fl__event--past, .fl__card--calendar'
            })
        }
        
        this._calendarAddEvents()
        
        this.past = !this.past
    }
}

const EVENTS = new EventsClass()
export default EVENTS